import React, { useState } from "react";
import "./feedbackForm.css";
import { fetchJoinUserApi } from "../../api/api";

const FeedbackForm = ({ onClose }) => {
  const [formData, setFormData] = useState({
    tools: [],
    findUsefull: "",
    improved: "",
    email: "",
    type: 1,
    name: ""
  });

  const [emailError, setEmailError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleCheckboxChange = (e) => {
    const { value, checked } = e.target;
    setFormData((prev) => {
      const tools = checked
        ? [...prev.tools, value]
        : prev.tools.filter((tool) => tool !== value);
      return { ...prev, tools };
    });
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
  e.preventDefault();

  if (!formData.email.trim()) {
    setEmailError("Email is required.");
    return;
  } else if (!validateEmail(formData.email)) {
    setEmailError("Please enter a valid email address.");
    return;
  } else {
    setEmailError("");
  }

  const submittedData = {
    ...formData,
    tools: formData.tools.join(", ")
  };

  try {
    const response = await fetchJoinUserApi(submittedData);
    if (response?.message) {
      setSuccessMessage(response.message);
    } else {
      setSuccessMessage("Submitted successfully.");
    }

    setFormData({
      tools: [],
      findUsefull: "",
      improved: "",
      email: "",
      type: 1,
      name: ""
    });

    setTimeout(() => {
      setSuccessMessage("");
      onClose();
    }, 1000);
  } catch (err) {
    setEmailError("Something went wrong. Please try again.");
  }
};

  return (
    <div className="AF-popupOverlay">
      <div className="AF-popup-feed">
        <div className="AF-header-feed">
           <h1>Feedback Form</h1>
          <button className="AF-closeBtnLeft-feed" onClick={onClose}>×</button>
        </div>
        
        {successMessage && <p className="success-msg-fe">{successMessage}</p>}

        <form onSubmit={handleSubmit}>
          <label className="form-label-join">1. Which tool(s) did you use?</label>
          <div className="checkbox-group-new">
            {["Multibet", "Treble", "Bet Builder"].map((tool) => (
              <label key={tool} className="checkbox-label">
                <input
                  type="checkbox"
                  value={tool}
                  checked={formData.tools.includes(tool)}
                  onChange={handleCheckboxChange}
                />
                <span className="input-ch-label">{tool}</span>
              </label>
            ))}
          </div>

          <label className="form-label-join">2. What did you like or find useful?</label>
          <textarea
            name="findUsefull"
            placeholder="Write here ..."
            value={formData.findUsefull}
            onChange={handleChange}
            rows={2}
          />

          <label className="form-label-join">3. What could be improved or added?</label>
          <textarea
            name="improved"
            placeholder="Write here ..."
            value={formData.improved}
            onChange={handleChange}
            rows={2}
          />

          <label className="form-label-join">
            4. Leave your email if you'd like early access or launch offers
          </label>
          <input
            type="text"
            name="email"
            placeholder="Your@example.com"
            value={formData.email}
            onChange={handleChange}
          />
          {emailError && <p className="email-error-msg">{emailError}</p>}

          <div className="AF-buttonGroup">
            <button type="submit" className="AF-submitBtn">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default FeedbackForm;
